import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './App.css';
import { useSpring, a } from '@react-spring/web';
import GooeyLink from './GooeyLink';
import AnimatedCursor from 'react-animated-cursor';
import { useTheme } from './ThemeContext';

// Import all images from the Kins folder
import dia1 from './images/Kins/Kins1.png';
import dia2 from './images/Kins/Kins2.png';
import dia3 from './images/Kins/Kins3.png';
import dia4 from './images/Kins/Kins4.png';
import dia5 from './images/Kins/Kins5.png';
import dia6 from './images/Kins/Kins6.png';
import dia7 from './images/Kins/Kins7.png';
import dia8 from './images/Kins/Kins8.png';
import dia9 from './images/Kins/Kins9.png';
import dia10 from './images/Kins/Kins10.png';
import dia11 from './images/Kins/Kins11.png';
import dia12 from './images/Kins/Kins12.png';
import dia13 from './images/Kins/Kins13.png';


function Kins() {
  // Create an array of all images
  const diaImages = [dia1, dia2, dia3, dia4, dia5, dia6, dia7, dia8, dia9, dia10, dia11, dia12, dia13];
  
  // Use the theme context
  const { isDarkMode, toggleDarkMode } = useTheme();
  
  // Update color based on dark mode
  const [{ color }] = useSpring({ 
    color: isDarkMode ? '#FFFFFF' : '#000000' 
  }, [isDarkMode]);
  
  // Add this near the top of your component
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      {/* Full-width background */}
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: isDarkMode ? '#121212' : '#EFEFEF',
        zIndex: -1
      }} />
      
      <div className="kins-page" style={{ 
        margin: '0 36px',
        position: 'relative',
        minHeight: '100vh'
      }}>
        {/* Navigation Bar - same as main page */}
        <a.div className="App-navigation" style={{ 
          color,
          position: 'relative',
          width: '100%',
          padding: '24px 0',
          marginTop: '0',
          transition: 'background 0.3s ease, color 0.3s ease'
        }}>
          <Link to="/" style={{ textDecoration: 'none' }}>
            <a.span className="name" style={{ color }}>Lou Kishfy</a.span>
          </Link>
          <div className="citySpan" style={{ 
            position: 'absolute', 
            left: '50%', 
            transform: 'translateX(-50%)',
            top: '26px',
            width: 'auto',
            textAlign: 'center'
          }}>
            <a.span style={{ color }}>New York, New York</a.span>
          </div>
          <div className="nav-links">
            <a.span className="link-spacing" style={{ color }}>
              {/* Add dark mode toggle button if desired */}
      
            </a.span>
            <a.span className="link-spacing" style={{ 
              color,
              transform: 'translate(16px, -.5px)', 
              display: 'inline-block'
            }}>
              <GooeyLink 
                href="mailto:louis.kishfy@gmail.com?subject=Hey Lou, reaching out to..." 
                target="_blank"
                isDarkMode={isDarkMode}
                textColor={color}
              >
                Contact Me
              </GooeyLink>
            </a.span>
          </div>
        </a.div>
        
        {/* Grey divider that spans full width */}
        <div style={{ 
          width: '100%',
          height: '1px', 
          backgroundColor: isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)', 
          margin: '48px 0px 16px 0px',
          position: 'relative',
        }}></div>
        
        {/* Header */}
        <div style={{ marginBottom: '40px' }}>
          <h1 style={{ 
            fontSize: '48px', 
            fontWeight: '600', 
            color: isDarkMode ? '#FFFFFF' : '#000000' 
          }}>
            Kins
          </h1>
          <p style={{ 
            fontSize: '18px', 
            maxWidth: '800px', 
            color: isDarkMode ? '#FFFFFF' : '#000000' 
          }}>
            End-to-end product development for Kins
          </p>
        </div>
        
        {/* Info and Team Section */}
        <div style={{ 
          display: 'flex', 
          flexDirection: isMobile ? 'column' : 'row', 
          marginBottom: '60px',
          gap: isMobile ? '30px' : '60px'
        }}>
          {/* Info Section */}
          <div style={{ flex: '1' }}>
            <h3 style={{ 
              fontSize: '16px', 
              fontWeight: '600',
              marginBottom: '12px',
              color: isDarkMode ? '#FFFFFF' : '#000000'
            }}>
              Info
            </h3>
            <p style={{ 
              fontSize: '16px',
              lineHeight: '1.5',
              color: isDarkMode ? '#FFFFFF' : '#000000'
            }}>
              Kins is a hybrid digital and in-person virtual physical therapy platform. I was brought on as the first product designer to help take the company from -1 to 1. I worked closely with the founding team to design the product from scratch, including the brand, user experience, and interface design.
            </p>
          </div>
          
          {/* Team Section */}
          <div style={{ flex: '1' }}>
            <h3 style={{ 
              fontSize: '16px', 
              fontWeight: '600',
              marginBottom: '12px',
              color: isDarkMode ? '#FFFFFF' : '#000000'
            }}>
              Team
            </h3>
            <p style={{ 
              fontSize: '16px',
              lineHeight: '1.5',
              color: isDarkMode ? 'rgba(255,255,255,0.8)' : '#555' // Adjusted for dark mode
            }}>
             Product Design: Lou Kishfy, Run Chen<br />
             Product Management: Lou Kishfy<br />
            Software Development: Contract partners
            </p>
          </div>
        </div>
        
        {/* Image Gallery */}
        <div style={{ marginBottom: '60px' }}>
          <div style={{ 
            display: 'grid',
            gridTemplateColumns: '1fr',
            gap: '20px'
          }}>
            {diaImages.map((image, index) => (
              <div key={index} style={{ 
                width: '100%',
                borderRadius: '4px',
                overflow: 'hidden',
                boxShadow: isDarkMode ? '0 4px 20px rgba(0,0,0,0.3)' : '0 4px 20px rgba(0,0,0,0.1)'
              }}>
                <img 
                  src={image} 
                  alt={`Kins project ${index + 1}`} 
                  style={{ 
                    width: '100%', 
                    height: 'auto',
                    display: 'block'
                  }} 
                />
              </div>
            ))}
          </div>
        </div>
        
        {/* Grey divider that spans full width */}
        <div style={{ 
          width: '100%',
          height: '1px', 
          backgroundColor: isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)', 
          margin: '48px 0px 16px 0px',
          position: 'relative',
        }}></div>
        
        {/* Footer - exact match from App.js */}
        <a.div id="contact" className="footer" style={{ 
          marginTop: '40px',
          paddingTop: '0px',
          paddingBottom: '40px',
          paddingLeft: '0px',
          color
        }}>
          <div style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            gap: '20px',
            marginBottom: '20px',
            marginLeft: '0px'
          }}>
            <h3 style={{ 
              fontSize: '24px', 
              fontWeight: '600', 
              marginBottom: '16px',
              marginLeft: '0px',
              color: isDarkMode ? '#FFFFFF' : '#000000'
            }}>Find Me</h3>
            <div style={{ 
              display: 'flex', 
              flexDirection: 'column', 
              gap: '20px',
              marginBottom: '10px'
            }}>
              <GooeyLink 
                href="mailto:louis.kishfy@gmail.com" 
                isDarkMode={isDarkMode}
                textColor={color}
              >
                Email
              </GooeyLink>
              <GooeyLink 
                href="https://www.linkedin.com/in/louis-kishfy/" 
                target="_blank" 
                isDarkMode={isDarkMode}
                textColor={color}
              >
                LinkedIn
              </GooeyLink>
              <GooeyLink 
                href="https://github.com/LouisKishfy" 
                target="_blank" 
                isDarkMode={isDarkMode}
                textColor={color}
              >
                GitHub
              </GooeyLink>
              <GooeyLink 
                href="https://www.figma.com/@LouKishfy" 
                target="_blank" 
                isDarkMode={isDarkMode}
                textColor={color}
              >
                Figma
              </GooeyLink>
            </div>
            <div style={{ textAlign: 'left', display: 'inline-block', marginLeft: '0px' }}>
              <GooeyLink 
                href="https://x.com/louiskishfy" 
                target="_blank" 
                isDarkMode={isDarkMode}
                textColor={color}
              >
                X
              </GooeyLink>
            </div>
          </div>
          <div style={{ 
            marginTop: '30px', 
            textAlign: 'left',
            fontSize: '14px',
            opacity: 0.7,
            width: '100%'
          }}>
            <a.p style={{ color }}>© {new Date().getFullYear()} Lou Kishfy. All rights reserved.</a.p>
          </div>
        </a.div>
      </div>
    </>
  );
}

export default Kins; 